// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyUnitInfo_faculty-unit__nVyKT {
  display: flex;
  gap: 10px;
  flex-direction: column;
}
.FacultyUnitInfo_faculty-unit--item__aAtjf {
  padding-bottom: 5px;
}
.FacultyUnitInfo_faculty-unit--item__aAtjf:not(:last-child) {
  border-bottom: 1px solid var(--light-grey);
}
.FacultyUnitInfo_faculty-unit--item--name__10WXa {
  font-size: 14px;
  font-weight: 600;
}
.FacultyUnitInfo_faculty-unit--item--sub-name__mkpQ1 {
  font-size: 14px;
  margin-bottom: 5px !important;
}
.FacultyUnitInfo_faculty-unit--item__aAtjf .FacultyUnitInfo_link__9UOKx:hover, .FacultyUnitInfo_faculty-unit--item__aAtjf .FacultyUnitInfo_link__9UOKx:hover > * {
  color: var(--blue) !important;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/FacultyUnitInfo/FacultyUnitInfo.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,0CAAA;AACN;AAEI;EACE,eAAA;EACA,gBAAA;AAAN;AAGI;EACE,eAAA;EACA,6BAAA;AADN;AAKM;EAEE,6BAAA;EACA,0BAAA;AAJR","sourcesContent":[".faculty-unit {\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n\n  &--item {\n    padding-bottom: 5px;\n\n    &:not(:last-child) {\n      border-bottom: 1px solid var(--light-grey);\n    }\n\n    &--name {\n      font-size: 14px;\n      font-weight: 600;\n    }\n\n    &--sub-name {\n      font-size: 14px;\n      margin-bottom: 5px !important;\n    }\n\n    .link {\n      &:hover,\n      &:hover > * {\n        color: var(--blue) !important;\n        text-decoration: underline;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-unit": `FacultyUnitInfo_faculty-unit__nVyKT`,
	"faculty-unit--item": `FacultyUnitInfo_faculty-unit--item__aAtjf`,
	"faculty-unit--item--name": `FacultyUnitInfo_faculty-unit--item--name__10WXa`,
	"faculty-unit--item--sub-name": `FacultyUnitInfo_faculty-unit--item--sub-name__mkpQ1`,
	"link": `FacultyUnitInfo_link__9UOKx`
};
export default ___CSS_LOADER_EXPORT___;
